import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Kleiner Dialog zur Eingabe des Ablaufdatums für eine Demo-Offline-Lizenzdatei.
 * Schließt mit dem gewählten Datum (YYYY-MM-DD) oder null bei Abbruch.
 */
@Component({
  selector: 'app-dialog-offline-demo-date',
  templateUrl: './dialog-offline-demo-date.component.html',
})
export class DialogOfflineDemoDateComponent {
  expirationDate = new FormControl('', [Validators.required]);

  constructor(public dialogRef: MatDialogRef<DialogOfflineDemoDateComponent>) {}

  confirm() {
    if (this.expirationDate.valid) {
      this.dialogRef.close(this.expirationDate.value);
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
